import uuid from "shortid";
import { db } from "@/plugins/firebase";
import RequestsCache from "./requestsCache";
import { timestampToDate } from "../plugins/firebase";

const cachePeriodInMs = 1000 * 60; // 1 minute.
const requestsCache = new RequestsCache(cachePeriodInMs);

export const convertArrayToKeyedById = list => {
  let keyedById = {};
  for (let index = 0; index < list.length; index++) {
    let item = list[index];
    keyedById[item.id] = item;
  }
  return keyedById;
};

export const objectToArray = object => Object.values(object);

const _getResourceCacheKey = resourceType => `retrieveResource_${resourceType}`;

export function retrieveResource(resourceType, callback) {
  const cacheKey = _getResourceCacheKey(resourceType);
  requestsCache.getItem(cacheKey, (err, result) => {
    if (err) {
      db.collection(resourceType)
        .get()
        .then(querySnapshot => {
          let list = [];
          if (!querySnapshot.empty) {
            list = querySnapshot.docs.map(documentSnapShot =>
              documentSnapShot.data()
            );
          }
          // save to cache
          requestsCache.saveItem(
            cacheKey,
            convertArrayToKeyedById(
              list.map(obj => ({
                ...obj,
                created_on: timestampToDate(obj.created_on),
                last_modified: timestampToDate(obj.last_modified)
              }))
            ),
            (error, response) => {
              if (!error) callback(undefined, list);
              else callback(error);
              return response;
            }
          );
        })
        .catch(error => callback(error));
    } else {
      callback(undefined, objectToArray(result));
    }
  });
}

export function createResource(resourceType, data, callback) {
  const now = new Date();
  const id = data.id || uuid.generate();
  const newResourceInstance = {
    id,
    ...data,
    created_on: now,
    last_modified: now
  };
  db.collection(resourceType)
    .doc(id)
    .set(newResourceInstance)
    .then(() => {
      // update cache
      const cacheKey = _getResourceCacheKey(resourceType);
      requestsCache.getItem(cacheKey, (err, result) => {
        if (!err) {
          result[id] = newResourceInstance;
          requestsCache.saveItem(cacheKey, result, () => {});
        }
        callback(undefined, newResourceInstance);
      });
    })
    .catch(err => callback(err));
}

export function updateResource(resourceType, id, data, callback) {
  const newResourceInstance = {
    ...data,
    last_modified: new Date()
  };
  db.collection(resourceType)
    .doc(id)
    .update(newResourceInstance)
    .then(() => {
      // update cache
      const cacheKey = _getResourceCacheKey(resourceType);
      requestsCache.getItem(cacheKey, (err, result) => {
        if (!err) {
          const oldValue = result[id];
          result[id] = { ...oldValue, ...newResourceInstance };
          requestsCache.saveItem(cacheKey, result, () => {});
        }
        callback(undefined, result[id]);
      });
    })
    .catch(err => callback(err));
}

export function deleteResource(resourceType, id, callback) {
  db.collection(resourceType)
    .doc(id)
    .delete()
    .then(() => {
      // update cache
      const cacheKey = _getResourceCacheKey(resourceType);
      requestsCache.getItem(cacheKey, (err, result) => {
        if (!err) {
          delete result[id];
          requestsCache.saveItem(cacheKey, result, () => {});
        }
        callback(undefined, id);
      });
    })
    .catch(err => callback(err));
}

export function checkIfAdmin(email, callback) {
  /*
  Serverside authorization is very necessary, however
  */
  db.collection("admins")
    .doc(email.split("@gotugende.com")[0])
    .get()
    .then(doc => {
      if (doc.exists) {
        callback(undefined, true);
      } else {
        callback(undefined, false);
      }
    })
    .catch(err => callback(err));
}
